<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">版本管理</span></div>
		<div class="margin-top margin-left margin-right">
			<div style="display: flex;">
				<input type="text" v-model="versionNo" placeholder="输入版本号搜索" style="width: 240px;"
					   @keyup.enter="doSearch"/>
				<Button color="primary" :loading="loading" @click="doSearch">搜索</Button>
				<Button color="primary" style="margin-left: auto;" icon="fa fa-plus" @click="openForm()">新增版本</Button>
			</div>
		</div>
		<div class="h-panel-body">
			<Table :datas="dataList" :loading="loading">
				<TableItem prop="id" title="ID" :width="70"/>
				<TableItem prop="versionNo" title="版本号" :width="120"/>
				<TableItem prop="updateNotes" title="更新说明"/>
				<TableItem prop="downloadUrl" title="下载链接" :width="200"/>
				<TableItem title="发布日期" :width="150">
					<template slot-scope="{data}">
						{{ datetimeFormat(data.releaseDate) }}
					</template>
				</TableItem>
				<TableItem title="强制更新" :width="90" align="center">
					<template slot-scope="{data}">
						{{ data.forceUpdate === 1 ? '是' : '否' }}
					</template>
				</TableItem>
				<TableItem title="状态" :width="90" align="center">
					<template slot-scope="{data}">
						{{ data.status === 1 ? '已发布' : '已下架' }}
					</template>
				</TableItem>
				<TableItem title="操作" :width="120" align="center">
					<div class="actions" slot-scope="{data}">
						<span @click="openForm(data)">编辑</span>
						<span @click="remove(data)">删除</span>
					</div>
				</TableItem>
			</Table>
			<Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
						@change="loadList" small align="right"/>
		</div>

		<Modal v-model="showForm" hasCloseIcon hasDivider :closeOnMask="false">
			<div slot="header">{{ form.id ? '编辑版本' : '新增版本' }}</div>
			<Form :labelWidth="90" ref="form" :rules="validationRules" :model="form">
				<FormItem label="版本号" prop="versionNo">
					<input type="text" v-model="form.versionNo" maxlength="64" placeholder="例如：v1.2.0"/>
				</FormItem>
				<FormItem label="更新说明" prop="updateNotes">
					<textarea v-model="form.updateNotes" rows="4" maxlength="2000" placeholder="本次版本更新内容"></textarea>
				</FormItem>
				<FormItem label="下载链接" prop="downloadUrl">
					<input type="text" v-model="form.downloadUrl" maxlength="500" placeholder="https://..."/>
				</FormItem>
				<FormItem label="发布日期" prop="releaseDate">
					<input type="date" v-model="form.releaseDate"/>
				</FormItem>
				<FormItem label="强制更新">
					<Switch v-model="forceUpdate"/>
				</FormItem>
				<FormItem label="发布状态">
					<Switch v-model="status"/>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button @click="showForm=false">取消</Button>
				<Button color="primary" :loading="saving" @click="save">保存</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	import moment from 'moment';

	export default {
		name: "AdminVersionManagement",
		data() {
			return {
				loading: false,
				saving: false,
				showForm: false,
				versionNo: '',
				dataList: [],
				pagination: {page: 1, size: 20, total: 0},
				form: {},
				validationRules: {
					required: ['versionNo']
				}
			}
		},
		computed: {
			forceUpdate: {
				get() {
					return this.form.forceUpdate === 1;
				},
				set(value) {
					this.$set(this.form, 'forceUpdate', value ? 1 : 0);
				}
			},
			status: {
				get() {
					return this.form.status !== 0;
				},
				set(value) {
					this.$set(this.form, 'status', value ? 1 : 0);
				}
			}
		},
		methods: {
			loadList() {
				this.loading = true;
				this.$api.admin.versions({
					page: this.pagination.page,
					size: this.pagination.size,
					versionNo: this.versionNo || undefined
				}).then(({data}) => {
					this.dataList = data.records || [];
					this.pagination.total = Number(data.total || 0);
				}).finally(() => this.loading = false);
			},
			doSearch() {
				this.pagination.page = 1;
				this.loadList();
			},
			openForm(data) {
				if (data) {
					this.form = Object.assign({}, data);
					this.form.releaseDate = data.releaseDate ? moment(data.releaseDate).format('YYYY-MM-DD') : '';
				} else {
					this.form = {versionNo: '', updateNotes: '', downloadUrl: '', releaseDate: '', forceUpdate: 0, status: 1};
				}
				this.showForm = true;
			},
			save() {
				if (!this.$refs.form.valid().result) {
					return;
				}
				let body = Object.assign({}, this.form);
				body.releaseDate = body.releaseDate ? new Date(body.releaseDate + ' 00:00:00').getTime() : null;
				this.saving = true;
				let request = body.id
					? this.$api.admin.updateVersion(body)
					: this.$api.admin.addVersion(body);
				request.then(() => {
					this.$Message.success('保存成功~');
					this.showForm = false;
					this.loadList();
				}).finally(() => this.saving = false);
			},
			remove(data) {
				this.$Confirm(`确认删除版本【${data.versionNo}】?`).then(() => {
					this.$api.admin.deleteVersion({id: data.id}).then(() => {
						this.$Message.success('删除成功~');
						this.loadList();
					});
				});
			},
			datetimeFormat(date) {
				return date ? moment(date).format('YYYY-MM-DD') : '';
			}
		},
		mounted() {
			this.loadList();
		}
	}
</script>
